module.exports = __webpack_public_path__ + "images/trello-logo-blue.a185d94ba76be2701fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/trello-logo-blue.svg
// module id = FMFh
// module chunks = 24